import { FC, useCallback } from 'react';
import { matchPath, useLocation } from 'react-router-dom';
import { Icon, Link, NavigationSubmenuItem, Typography } from '../../shared';

import './NavigationLinks.scss';

interface NavigationLinksProps {
  expanded: boolean;
}

const NavigationLinks: FC<NavigationLinksProps> = ({ expanded }) => {
  const location = useLocation();

  const isActive = useCallback((currentRoute: string) => !!matchPath(currentRoute, location.pathname), [location]);

  return (
    <div className="nostra__navigationLinks">
      <Link href="/" className="nostra__navigationLinks__linkContainer">
        <div className="nostra__navigationLinks__linkIcon">
          <Icon variant="home" size={16} color={isActive('/') ? '--text-primary-darkbg' : '--icon-supporting'} />
        </div>
        <Typography
          className="nostra__navigationLinks__label"
          variant="nav-item"
          color={isActive('/') ? 'text-primary-darkbg' : 'text-supporting-darkbg'}
          weight={isActive('/') ? 'semi-bold' : 'regular'}
        >
          Dashboard
        </Typography>
      </Link>
      <Link href="/lend-borrow" className="nostra__navigationLinks__linkContainer">
        <div className="nostra__navigationLinks__linkIcon">
          <Icon
            variant="coin"
            size={16}
            color={
              isActive('/lend-borrow') || isActive('/lend-borrow/:ticker/:action')
                ? '--text-primary-darkbg'
                : '--icon-supporting'
            }
          />
        </div>
        <Typography
          className="nostra__navigationLinks__label"
          variant="nav-item"
          color={
            isActive('/lend-borrow') || isActive('/lend-borrow/:ticker/:action')
              ? 'text-primary-darkbg'
              : 'text-supporting-darkbg'
          }
          weight={isActive('/lend-borrow') || isActive('/lend-borrow/:ticker/:action') ? 'semi-bold' : 'regular'}
        >
          Lend & Borrow
        </Typography>
      </Link>
      <Link href="/swap" className="nostra__navigationLinks__linkContainer">
        <div className="nostra__navigationLinks__linkIcon">
          <Icon variant="swap" size={16} color={isActive('/swap') ? '--text-primary-darkbg' : '--icon-supporting'} />
        </div>
        <Typography
          className="nostra__navigationLinks__label"
          variant="nav-item"
          color={isActive('/swap') ? 'text-primary-darkbg' : 'text-supporting-darkbg'}
          weight={isActive('/swap') ? 'semi-bold' : 'regular'}
        >
          Swap
        </Typography>
      </Link>
      <Link href="/pools" className="nostra__navigationLinks__linkContainer">
        <div className="nostra__navigationLinks__linkIcon">
          <Icon
            variant="pool"
            size={16}
            color={
              isActive('/pools') || isActive('pools/:action/:pair') ? '--text-primary-darkbg' : '--icon-supporting'
            }
          />
        </div>
        <Typography
          className="nostra__navigationLinks__label"
          variant="nav-item"
          color={
            isActive('/pools') || isActive('pools/:action/:pair') ? 'text-primary-darkbg' : 'text-supporting-darkbg'
          }
          weight={isActive('/pools') || isActive('pools/:action/:pair') ? 'semi-bold' : 'regular'}
        >
          Pools
        </Typography>
      </Link>
      <Link href="/bridge" className="nostra__navigationLinks__linkContainer">
        <div className="nostra__navigationLinks__linkIcon">
          <Icon
            variant="bridge"
            size={16}
            color={isActive('/bridge') ? '--text-primary-darkbg' : '--icon-supporting'}
          />
        </div>
        <Typography
          className="nostra__navigationLinks__label"
          variant="nav-item"
          color={isActive('/bridge') ? 'text-primary-darkbg' : 'text-supporting-darkbg'}
          weight={isActive('/bridge') ? 'semi-bold' : 'regular'}
        >
          Bridge
        </Typography>
      </Link>
      <Link href="/claim" className="nostra__navigationLinks__linkContainer">
        <div className="nostra__navigationLinks__linkIcon">
          <Icon
            variant="spring-rewards"
            size={16}
            color={isActive('/claim') ? '--text-primary-darkbg' : '--icon-supporting'}
          />
        </div>
        <Typography
          className="nostra__navigationLinks__label"
          variant="nav-item"
          color={isActive('/claim') ? 'text-primary-darkbg' : 'text-supporting-darkbg'}
          weight={isActive('/claim') ? 'semi-bold' : 'regular'}
        >
          STRK Rewards
        </Typography>
      </Link>
      <NavigationSubmenuItem expanded={expanded} />
    </div>
  );
};
export default NavigationLinks;
